// extracted by mini-css-extract-plugin
module.exports = {"button":"buttons_button____s8M","primary":"buttons_primary__rVIjk","icon":"buttons_icon__o7fYa","secondary":"buttons_secondary__iKTcw"};